import { render, staticRenderFns } from "./ManualAlertPopup.vue?vue&type=template&id=b6722652&"
import script from "./ManualAlertPopup.vue?vue&type=script&lang=js&"
export * from "./ManualAlertPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports